<template>
    <div class="flex flex-col">
        <div class="p-2">
            {{ message.content.displayName }}
        </div>

        <div class="flex gap-2">
            <div v-for="(contact, k) in contacts" :key="k">
                <contact-component :message="contact" :instance-id="instanceId"></contact-component>
            </div>
        </div>
    </div>
</template>

<script>
    import ContactComponent from "./ContactComponent.vue";

    export default {
        props: {
            message: Object,
            instanceId: String
        },
        components: {
            ContactComponent
        },
        data() {
            return {
                contacts: []
            }
        },
        mounted() {
            this.contacts = this.message.content.contacts.map(contact => {
                return {
                    content: contact
                }
            });
        }

    }
</script>
